module.exports = __webpack_public_path__ + "static/media/playVideo2.fc0f4097.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/theme/components/images/playVideo2.png
// module id = 975
// module chunks = 0